export const totalUsdDepositRequired = 100;
export const totalUsdVolumeRequired = totalUsdDepositRequired * 50;
